import { columnsToSheet, saveXlsx } from "../../../../../functions/excelWriter";

export const exportChecklist = (data) => {
  //Columnas
  const columns = [
    { header: "ITEM", key: "nombre", width: 20 },
    { header: "DESC", key: "placeholder", width: 40 },
    { header: "VALOR", key: "value", width: 20 },
    { header: "OBSERVACIONES", key: "obs", width: 50 },
  ];
  const sheet = columnsToSheet(columns, data.campos_checklist, {
    //Estilos Cabecera
    headerStyle: {
      fontWeight: "bold",
      backgroundColor: "#a6d98c",
      alignVertical: "center",
    },
    cellStyle: { alignVertical: "center" },
  });
  return saveXlsx(
    [{ ...sheet, sheet: `Checklist maquina ${data.identificador_maquina}` }],
    `Checklist maquina ${data.identificador_maquina}`
  );
};
